import { useContext, useState, useEffect } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import TopBar from '../Interface/TopBar/TopBar';
import WidgetSources from '../../../components/widget/WidgetSources';
import { useTranslation } from 'react-i18next';
import styles from './EditorPlaceholder.module.css';
import api from '../../../../api/api.js';
import { InstagramLoginButton, FacebookLoginButton } from 'react-social-login-buttons';
import { isDemo, AppContext, WidgetsContext } from '../../../GlobalContex';
import useNotifications from '../../../hooks/useNotifications';
import { useAnalytics } from '../../../hooks/useAnalytics';
import { ReactComponent as TikTokSvg } from '../../../assets/tiktok-image.svg';

const EditorPlaceholder = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [modalState, setModalState] = useState(false);
  const { activeWidget, removeWidget, dataWidgetsList } = useContext(WidgetsContext);

  const { isEmbeded } = useContext(AppContext);

  const _removeWidget = async function () {
    await removeWidget(activeWidget.id);
    navigate('/home');
  };

  const widgetExeptionList = ['shop'];

  const widgetExeptionCheck = () => {
    return widgetExeptionList.indexOf(activeWidget?.app?.name) !== -1;
  }

  const username = activeWidget?.settings?.account?.username;

  const RemoveModal = widget => {
    return (
      <Modal show={modalState} onHide={() => setModalState(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t('Warning')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t(
            `Do you really want to remove ${activeWidget.title ? activeWidget.title : t('widget')}${
              username ? ' @' + username : ''
            }? WARNING! Once deleted, this ${
              activeWidget.title ? activeWidget.title : t('widget')
            } will be removed from ALL projects and published sites. This action cannot be undone.`
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalState(false)}>
            {t('Cancel')}
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              _removeWidget();
              setModalState(false);
            }}
          >
            {t('Remove')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const appName = activeWidget?.app?.name;
  const WidgetSource = WidgetSources[appName];

  return (
    <div className="bootstrap-app-styles builder-styles bg-white">
      {!widgetExeptionCheck() && <TopBar>{t('Add Source')}</TopBar>}
      <div className={`d-flex flex-column ${styles.container}`}>
        {WidgetSource && <WidgetSource></WidgetSource>}
        {!isDemo && (
          <>
            <RemoveModal />
            <Button className={`${WidgetSources[appName] ? 'mt-auto' : ''} btn-danger`} onClick={() => setModalState(true)}>
              {t('Remove widget')}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default EditorPlaceholder;
